export default function apiSubmitHandler(response) {
  if (response && response.message) {
    return response.message;
  } else {
    return "Your comment has been submitted!";
  }
}